import {format} from 'date-fns'
import {useLanguage} from './i18n'
import {getLocale} from './params'

export const formatDate = date => {
	return format(new Date(date.replace(/-/g, '/')), 'd MMM Y', {
		locale: getLocale(useLanguage())
	})
		.replace('jun.', 'juni')
		.replace('jul.', 'juli')
}
